import React from 'react';
import { Page, Document, Image, StyleSheet } from '@react-pdf/renderer';
import StatementTitle from './StatementTitle'
// import BillTo from './BillTo'
import StatementNo from './StatementNo'
import StatementItemsTable from './StatementItemsTable'
// import StatementThankYouMsg from './StatementThankYouMsg'


const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
        width: 74,
        height: 66,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
  });
  
  const Main = ({data}) => (
            <Document>
                <Page size="A4" style={styles.page}>
                    <StatementTitle title='HotelsOffline'/>
                    <StatementNo data={data}/>
                    <StatementItemsTable data={data} />
                </Page>
            </Document>
        );
  
  export default Main